
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CButton, CInput, CSpinner, CModal, CModalFooter, CModalBody, CModalHeader, CLabel,  CDropdown, CDropdownMenu, CDropdownItem, CDropdownToggle } from '@coreui/react';
import 'react-bootstrap-table/dist//react-bootstrap-table-all.min.css';
import axios from "../../../../config/axios";
import { toastr } from 'react-redux-toastr';

import URL from '../../../../config/api';
import { getShareRoles } from '../../../../helpers/doc';

class FolderModal extends Component { 
  constructor(props){
    super(props);
    this.state = {
      name: "",
      loading: false,
      selectedRoles: "Todos",
      roles: []
    }
  }

  componentDidMount() {
    getShareRoles(this.props.general.active_roles, this.props.user.token)
    .then(roles => {
      this.setState({
        roles: roles
      });
    }, (error) => { 
      this.error("Erro ao encontrar perfis");
    });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error('Falha', response);
    }
  }

  insertFolder() {
    if (this.state.name === "") {
      return;
    }

    this.setState({ loading: true });
    
    let roles = this.state.roles;

    if (this.state.selectedRoles === "Apenas eu") {
      roles = [];
    } else if (this.state.selectedRoles !== "Todos") {
      roles = roles.filter(item => item.role_name === this.state.selectedRoles);
    }

    axios.post(URL.api + 'content/doc/insert', { doc_id: this.props.doc_id, folder: true, name: this.state.name, user_id: this.props.user.user.id, type_id: 17, role: roles }, { headers: { Authorization: 'Bearer ' + this.props.user.token } })
    .then(resp => {
      this.setState({ name: "", loading: false });
      this.props.onClose(resp.data.data);
    }, (error) => { 
      this.error(error.response.statusText);
    });
  }

  render() {
    return (
      <CModal 
        size="md"
        centered
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          Criar nova pasta
        </CModalHeader>
        <CModalBody>
          <CLabel className="font-weight-bold">Nome da pasta</CLabel>
          <CInput type="text" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} placeholder="Digite o nome da pasta" />
        </CModalBody>
        <CModalFooter className="d-flex justify-content-between">
          <CDropdown className="ml-2" style={{ border: "1px solid #d8dbe0", borderRadius: "0.25rem" }}>
            <CDropdownToggle><span className="mr-1"><i className="fa fa-share-alt mr-1"></i> {this.state.selectedRoles}</span></CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem onClick={() => this.setState(state => ({ selectedRoles: 'Todos' }))} active={this.state.selectedRoles === 'Todos'}>Todos</CDropdownItem>
              {this.state.roles.map(role => (
                <CDropdownItem onClick={() => this.setState({ selectedRoles: role.role_name })} active={this.state.selectedRoles === role.role_name}>{role.role_name}</CDropdownItem>
              ))}
              <CDropdownItem onClick={() => this.setState({ selectedRoles: 'Apenas eu' })} active={this.state.selectedRoles === 'Apenas eu'}>Apenas eu</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
          <div className="d-flex">
            <CButton disabled={this.state.loading} color="primary" className="d-flex justify-content-center align-items-center mr-2" onClick={() => this.insertFolder()}>
              <span className={this.state.loading ? "invisible" : ""}>Criar</span>
              {this.state.loading && (
                <CSpinner size="sm" color="white" style={{ position: "absolute" }}/>
              )}
            </CButton>{' '}
            <CButton disabled={this.state.loading} color="secondary" onClick={() => this.props.onClose()}>Cancelar</CButton>
          </div>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({user: state.user, general:state.general, profile:state.profile, form:state.form})

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    
  }, dispatch);
}

export default (connect(mapStateToProps, mapDispatchToProps)(FolderModal));